// extracted by mini-css-extract-plugin
export default {"root":"style_root__LouA6","opponent":"style_opponent__fggSj","inner":"style_inner__pXVy5","front":"style_front__K41bC","back":"style_back__svxP6"};